import type { RouteRecordRaw } from "vue-router";

export const AuthRoutes = <RouteRecordRaw[]>[
  {
    name: "login-root",
    path: "/",
    component: () => import("./AuthContainer.vue"),
    children: [
      {
        path: "",
        name: "entry",
        redirect: { name: "login" },
      },
      {
        path: "/:catchAll(.*)",
        redirect: { name: "login" },
      },
      {
        path: "login",
        name: "login",
        component: () => import("./Login/LoginView.vue"),
        meta: {
          public: true,
          hideNavbar: true,
          showTheme: true,
          showLanguage: true,
        },
      },
      {
        path: "404",
        name: "404",
        component: () => import("./404Page.vue"),
        meta: {
          public: true,
          hideNavbar: true,
          showTheme: true,
          showLanguage: true,
        },
      },
      {
        path: "oauth/v2/callback",
        name: "callback",
        component: () => import("@cms/features/Auth/Login/LoginCallback.vue"),
        meta: {
          public: true,
          hideNavbar: true,
          showTheme: true,
          showLanguage: true,
        },
      },
      {
        path: "error",
        name: "error",
        component: () => import("./Login/LoginError.vue"),
        meta: {
          public: true,
          hideNavbar: true,
          showTheme: true,
          showLanguage: true,
        },
      },
      {
        path: "logout",
        name: "logout",
        component: () => import("./Logout/LogoutPage.vue"),
        meta: {
          public: true,
          hideNavbar: true,
          showTheme: true,
          showLanguage: true,
        },
      },
      {
        path: "config-override",
        name: "config-override",
        component: () => import("./Config/ConfigOverridePage.vue"),
        meta: {
          public: true,
          hideNavbar: true,
          showTheme: true,
          showLanguage: true,
          skipAuthChecks: true,
        },
      },
    ],
  },
];

export default AuthRoutes;
